
<template>
<v-container fill-height>
  <v-row align="center" justify="center">

      {{$t("Settings.language")}}
      <flag class="ml-3" :iso="flag" :squared="false" />
      <dialog-lang @saved="saveLang" @error="$emit('error',value)" :id="id" :lang="langArray"></dialog-lang>
  </v-row>
</v-container>
</template>

<script>

import DialogLangComponent from './DialogLang'
import languageStore from '../../store/LanguageStore'


export default {
  components:{
    'dialog-lang':DialogLangComponent
  },
  props: {
    id: String,
  },
  data () {
    return {
      lang : null,
      langArray: [
        {
          flag: "fr",
          lang: "fr"
        },
        {
          flag: "us",
          lang: "en"
        }
      ]
    }
  },
  computed:{
    flag: function(){
      switch(this.lang){
        default:
          return this.lang;
        case 'fr' :
          return 'fr'
        case 'en' :
          return 'us'

      }
    }
  },
  methods:{
    saveLang: function(value){
      this.lang = value;
      this.$emit("savelang", value);
    }
  },
  beforeMount: function() {
    this.lang = languageStore.getLang();
  }
};
</script>